import logo from 'images/communities/Houston/logo.png'
import dashboardHeaderImage from 'images/communities/Houston/banner.jpg'
import loginBackgroundImg from 'images/communities/Houston/background-image.jpg'
import mapHeaderImage from 'images/communities/Houston/landing.jpg'
import favicon from 'images/communities/Houston/favicon.png'
import homeLogo from 'images/home/community-logos/houston.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/houston-video-button-image.png'

const config = {
  subdomain: 'houston',
  name: 'Houston',
  position: 5,
  partnerSupportEmail: 'artlooksupport@artsconnecthouston.org',
  schoolSupportEmail: 'artlooksupport@artsconnecthouston.org',
  artistSupportEmail: 'artlooksupport@artsconnecthouston.org',
  stylesheet: 'houston.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://www.artsconnecthouston.org',
  faqUrl:
    'https://drive.google.com/file/d/1nTv22AqYmydKSDGeWjXRXY22bztUenrU/view?usp=sharing',
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: false,
  schoolProfileCompletionEnabled: false,
  teachingArtistProfileCompletionEnabled: false,
  surveyCompletionEnabled: false,
  showRecentLoginOnPublicPage: false,
  portalSignInEnabled: true,
  googleLoginEnabled: true,
  partnerProgramsEnabled: true,
  educatorEnabled: false,
  notificationsEnabled: true,
  notificationListSize: -1,
  dataDashboardEnabled: true,
  partnerRegisterEnabled: false,
  id: 10,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: false,
  registerEnabled: false,
  provideOwnPrograms: false,
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: ['networks', 'creativeSchoolsCategory'],
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  map: {
    center: { lat: 29.7594466, lng: -95.3702107 },
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'hou-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: "Houston's homepage",
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'Arts Connect Houston',
  },
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: mapHeaderImage,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title: 'artlook Map: Increasing Arts Education in Houston',
    searchHeader: 'Find Schools & Partners in Houston',
    welcomeSearchHeader: 'Explore Arts Education in Houston',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> Houston</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
           artlook<sup>®</sup> ${config.name} is a free online hub created to help connect schools, educators, and the 
           community in providing arts learning opportunities for every student.  
          </p>
          <p>
            Developed by Ingenuity in Chicago and customized as a collaboration among local teachers, school and 
            district administrators, arts partners, and Arts Connect Houston staff, artlook® provides an up-to-date 
            picture of the people, places, and programs supporting arts learning in Houston.  
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the public Map and Directory available on this site, artlook also enhances the way that 
            Arts Connect Houston is able to provide data analysis and reporting to arts educators, advocates, and 
            funders with the goal of strengthening a diverse, robust arts education system in our region.    
          </p>
          <p>
            Arts Connect Houston invites arts partners in the region to join artlook® Houston. Contact us at 
            <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> 
            to get on the map! 
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: {
      title: `Find Schools`,
      text: `
        <p>
          If you’re an arts organization or teaching artist, search for schools in need of programs that you offer. 
          Reach out!
        </p>
        <p>
          If you’re a parent looking for an arts-rich or discipline-specific school for your child, find schools that 
          provide what you’re looking for.
        </p>
      `,
    },
    findProgramsCard: {
      title: `Find Arts Programs and Organizations`,
      text: `
        <p>
          If you’re a school in need of arts programs, partnerships, or resources, search for arts orgs that provide 
          what you’re looking for. New arts ed partners are waiting to connect!
        </p>
      `,
    },
    findDataCard: {
      title: `Find Data`,
      text: `
        <p>
          If you’re an advocate for a stronger, more vibrant arts education landscape in ${config.name}, exploring artlook 
          helps you make new connections, tap into new opportunities, and find fresh insights through data.
        </p>
      `,
    },
    justExploreCard: {
      title: `Just Explore`,
      text: `
        <p>
          The artlook<sup>®</sup> ${config.name} Map contains the most comprehensive picture of arts ed in our region - 
          go search, explore, and learn more about the arts in our schools -- as well as where we need to bring more 
          arts to more students.
        </p>
      `,
    },
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        This (free!) publicly-available and searchable map is the only one of its kind in ${config.name} to capture 
        information on arts education from schools, arts organizations, and teaching artists. Using the Search 
        function above, you can explore the arts ed programs and resources available to students in schools and via 
        partners throughout the region.  
      <p>
        The Map and Directory provide an up-to-date picture of what’s happening in arts ed and where, as well as 
        contact info to connect directly to these schools and arts organizations. GO EXPLORE & CONNECT to bring more 
        arts to more students!
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl:
        'https://www.youtube.com/embed/OeqCbofkUi8?si=988vOCj6wdLTqNEW&amp;controls=0',
      iframeTitle: 'Houston artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup> Houston',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  tagline:
    'Uniting the Greater Houston community to ensure access to high-quality arts education for every student',
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Houston</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Houston</em> is the only platform of its kind that combines data from Houston ISD schools and arts education program providers (like you!). The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in our community.
        </p>
        <p>
          <strong>To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</strong>
        </p>
        <p>
          If you have any questions or need assistance, please contact <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>.
        </p>
      `,
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> Houston</em> is YOUR gallery for arts education data</h3>
        <p>
          <em>artlook<sup>®</sup> Houston</em> is the only platform of its kind that combines data from Houston ISD schools (like you!) and arts education program providers. The goal is to build direct connections between arts providers and schools to expand equitable access to quality arts education programming for EVERY student in our community.
        </p>
        <p>
          <strong>To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share your school's arts education offerings.</strong>
        </p>
        <p>
          If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
        </p>
      `,
    },
  },
  survey: {
    getStarted: `<h2>Welcome to the {{ surveySchoolYearNumber }} Creative Schools Survey!</h2>
    <p>Through this annual survey, you will be asked to share information about arts education staffing and instruction at your school, partnerships with arts partners (i.e. arts organizations), and how your school budgets and plans for the arts.</p>
    <p>As you work on the {{ surveySchoolYearNumber }} survey, please be sure to frequently save your responses to each question to avoid losing information. You are not required to complete your survey in one session; saving your responses as you go will allow you to return at any time to complete or edit your survey before submitting.</p>
    <p>Please feel free to reach out to <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> with any questions!</p>
    <div class="callout">
      <p><strong>Benefits of completing the survey:</strong></p>
      <ul class="checkmark-list">
        <li><span>Completion makes your school eligible to receive dollars for arts education partnerships through the Arts Action Fund</span></li>
        <li><span>Use the artlook<sup>®</sup> Map to showcase your school and get connected to new arts education programs and resources, including virtual programs</span></li>
        <li><span>Help the HISD community advance towards excellent, equitable arts education for all students by providing data on needs and opportunities</span></li>
      </ul>
    </div>
    `,
    staffingQuestion: {
      modalMessage: `
        <p>
        <strong>Note on instructors:</strong> Restrict the list of instructors in your school to those teaching an arts course during the school day. Note that district-run/district-managed schools require arts instructors to hold a state certification or endorsement in one of the following arts disciplines: visual arts, media arts, music, theater, and/or dance. Charter schools, contract schools, and Pre-K-only schools do not have this requirement. If itinerant teachers teach at your school, please report those individuals as well.
        </p>
        <p>
        <strong>Note on part/full-time status:</strong> Please select Full Time if a teacher had full-time status at your school for the entire school year. If a teacher was part-time at your school for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
        <strong>Note on disciplines:</strong> The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
        `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  GOVERNANCE,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  DISTRICT_SPENDING,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.PER_DISCIPLINE,
  governance: GOVERNANCE.OPTIONS.GENERAL,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  districtSpending: DISTRICT_SPENDING.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

export default config
